// extracted by mini-css-extract-plugin
export default {"viewmsg":"ViewSchedMessages_viewmsg__s0+47","title":"ViewSchedMessages_title__zebzz","content":"ViewSchedMessages_content__Dp8eu"};